import { render, staticRenderFns } from "./QuoteSubmittedStateCard.vue?vue&type=template&id=f38f537a&"
import script from "./QuoteSubmittedStateCard.vue?vue&type=script&lang=ts&"
export * from "./QuoteSubmittedStateCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports